import React from "react";
import { Box } from "@mantine/core";
import { IconChevronRight } from "@tabler/icons-react";
import BottomSheet from "../../../common/BottomSheet";
import { ReportFilterDef } from "../../../../types/reportsV2";
import SheetOption from "./SheetOption";
import styles from "./MobileSheets.module.css";

export interface MobileAddFilterSheetProps {
  opened: boolean;
  onClose: () => void;
  /** Filters not yet shown in the chip row. */
  filters: ReportFilterDef[];
  onPick: (key: string) => void;
}

/** "+ Filter" on a phone: pick one of the report's other filters. */
export default function MobileAddFilterSheet({
  opened,
  onClose,
  filters,
  onPick,
}: MobileAddFilterSheetProps) {
  return (
    <BottomSheet
      labelDialog
      opened={opened}
      onClose={onClose}
      title="Add a filter"
      data-testid="report-add-filter-sheet"
    >
      <Box className={styles.options}>
        {filters.map((f) => (
          <SheetOption
            key={f.key}
            label={f.label}
            trailing={<IconChevronRight size={16} aria-hidden />}
            onClick={() => onPick(f.key)}
          />
        ))}
      </Box>
    </BottomSheet>
  );
}
